import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeIcon } from './mixins';
import spriteUrl from '../../assets/icons/sprite.svg';
var I = styled.i(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeIcon(props);
});
export var Icon = function Icon(props) {
  var name = props.name;
  return React.createElement(I, Object.assign({
    className: "icon-".concat(name)
  }, props, {
    source: spriteUrl
  }));
};
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string
};
Icon.defaultProps = {
  color: '#000000',
  size: '20'
};